import { render, staticRenderFns } from "./AutorizOnline.vue?vue&type=template&id=20bacb54&"
import script from "./AutorizOnline.vue?vue&type=script&lang=js&"
export * from "./AutorizOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports